import { NavigateFunction } from 'react-router-dom';
import { mergeSearchQuery } from 'utils/queries';

const pushStates = <TQuery extends object>(
  location: { search: string; pathname: string },
  navigate: NavigateFunction,
  query: TQuery,
) => {
  const { search, pathname } = location;
  const queries = mergeSearchQuery(search, query);
  navigate(`${pathname}${queries}`);
};

export default pushStates;
